<template>
    <modal
        size="lg"
        :open="show"
        @close="show = false"
    >
        <form class="flex flex-col flex-wrap w-full space-y-3 text-white" @submit.prevent="submit">
            <h1 class="border-b pb-2 mb-2 border-slate-500">Alterar Telefone</h1>

            <div class="mb-4">
                <div
                    v-for="(error, index) in errors"
                    :key="index"
                    class="text-red-500">
                    {{ error }}
                </div>
            </div>

            <CountriesSelect
                :columns="{ sm: 12, md: 12, lg: 12, xs: 12 }"
                name="ddi"
                label="DDI"
                v-model="ddi"
            />

            <div class="flex flex-col gap-1">
                <label for="phone">Telefone</label>
                <input
                    type="text"
                    id="phone"
                    class="w-full text-input"
                    v-model="phone"
                    @input="formatPhoneInput"
                    :placeholder="phoneMaskPlaceholder"
                    required
                >
            </div>

            <div class="flex flex-col gap-1">
                <label for="reason">Motivo:</label>
                <input
                    type="text"
                    id="reason"
                    class="w-full text-input"
                    v-model="reason"
                    required
                >
            </div>


            <submit-button
                :loading="loading"
                :disabled="loading"
                class="w-full"
            >
                Enviar
            </submit-button>
        </form>
    </modal>
</template>

<script>
import Modal from "../../../components/layouts/Modal.vue";
import SubmitButton from "../../../components/forms/SubmitButton.vue";
import { useToast } from "vue-toastification";
import { defineAsyncComponent } from "vue";
const CountriesSelect = defineAsyncComponent(() => import('../../countriesSelect/CountriesSelect.vue'));

export default {
    props: ['user', 'show'],
    components: {SubmitButton, Modal, CountriesSelect},

    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            loading: false,
            phone: this.getLatestPhoneWithType() ? this.getLatestPhoneWithType().ddd + this.getLatestPhoneWithType().number : '',
            ddi: this.getLatestPhoneWithType() ? this.getLatestPhoneWithType().ddi : '+55',
            phone_id: this.getLatestPhoneWithType() ? this.getLatestPhoneWithType().id : '',
            reason: '',
            errors: []
        }
    },

    mounted() {
        // Aplica máscara inicial quando o componente é montado
        this.$nextTick(() => {
            this.applyPhoneMask();
        });
    },

    computed: {
        phoneMaskPlaceholder() {
            if (this.ddi === '+55') {
                return '(XX) 9 XXXX-XXXX';
            }
            return 'XXXXXXXXXXXX';
        }
    },

    watch: {
        show(newVal) {
            if (newVal) {
                // Quando o modal abre, aplica a máscara ao telefone
                this.$nextTick(() => {
                    this.applyPhoneMask();
                });
            } else {
                // Quando o modal fecha, reseta os dados
                this.resetForm();
            }
        },
        ddi(newVal) {
            // Quando o DDI muda, reaplica a máscara
            this.$nextTick(() => {
                this.applyPhoneMask();
            });
        }
    },

    methods: {
        getLatestPhoneWithType() {
            if (!this.user.phones || this.user.phones.length === 0) {
                return '';
            }

            const phoneWithType = this.user.phones
                .filter(p => p.type)
                .sort((a, b) => b.id - a.id);

            if (phoneWithType.length > 0) {
                return phoneWithType[0];
            }

            return "";
        },
        formatPhoneInput(event) {
            let value = this.phone.replace(/\D/g, '');

            if (this.ddi === '+55') {
                // Máscara brasileira: (XX) 9 XXXX-XXXX
                if (value.length <= 2) {
                    this.phone = value;
                } else if (value.length <= 7) {
                    this.phone = `(${value.slice(0, 2)}) ${value.slice(2)}`;
                } else {
                    this.phone = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
                }
            } else {
                // Para outros países, apenas mostra números
                this.phone = value;
            }
        },
        applyPhoneMask() {
            // Aplica a máscara ao valor atual do telefone
            if (this.phone) {
                this.formatPhoneInput();
            }
        },
        resetForm() {
            // Reseta o formulário quando o modal fecha
            const latest = this.getLatestPhoneWithType();
            if (latest) {
                this.phone = latest.ddd + latest.number;
                this.ddi = latest.ddi;
                this.phone_id = latest.id;
            } else {
                this.phone = '';
                this.ddi = '+55';
                this.phone_id = '';
            }
            this.reason = '';
            this.errors = [];
        },
        submit() {
            this.errors = [];
            this.loading = true;

            axios.put('/api/user/' + this.user.id + '/phone/' + this.phone_id, {
                ddi: this.ddi,
                phone: this.phone,
                reason: this.reason
            }).then(() => {
                this.loading = false;
                this.toast.success('Telefone alterado com sucesso!');
                this.$emit('closeModalAndFetch');
            }).catch(({response}) => {
                if(response.data.errors){
                    this.errors = Object.values(response.data.errors).flat();
                }

                if(response.data.message) {
                    this.errors[this.errors.length + 1] = response.data.message;
                }
            }).finally(() => {
                this.loading = false;
            })
        },

    }
}
</script>
